<template>
  <div :ref="'carousel' + carouselid" :id="'carousel' + carouselid" class="carousel slide">
    <div class="carousel-inner">
      <div v-for="img in images" v-bind:key="img.id" class="carousel-item" :class=" { 'active': img.id == 0 } ">
        <img class="d-block w-100" :src="img.src" :alt="img.name">
      </div>
    </div>
    <template v-if="images.length > 1">
      <a class="carousel-control-prev" :href="'#carousel' + carouselid" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon d-block d-xl-none " aria-hidden="true"></span>
      </a>
      <a class="carousel-control-next" :href="'#carousel' + carouselid" role="button" data-slide="next">
        <span class="carousel-control-next-icon d-block d-xl-none" aria-hidden="true"></span>
      </a>
    </template>
    <span class="float-sm-left" >{{ curImageIndex.carouselid }}&nbsp;<small>of</small>&nbsp;{{ images.length }}</span>
  </div>
</template>

<script>
import jQuery from "jquery";
export default {
  name: 'Slideshow',
  props: {
    carouselid: String,
    images: Array
  },
  mounted: function () {
    const myName = 'carousel'+this.carouselid;
    if (jQuery('#'+myName).length > 0)
    {
      const self = this
      jQuery('#'+myName).on('slid.bs.carousel',function(e){
        self.curImageIndex.carouselid = jQuery(e.relatedTarget).index()+1;
        jQuery('#'+myName).carousel("pause");
      });
    }
  },
  data (){
    return {
      curImageIndex: {carouselid : 1},
    }
  }
}
</script>

<style scoped>
.carousel {
  cursor: pointer;
}
.carousel-control-next {
  cursor: url(/img/arrow.png) 83 0, pointer;
}
.carousel-control-prev {
  cursor: url(/img/arrow2.png) 0 0, pointer;
}

_:-ms-lang(x), .carousel-control-prev {
  cursor: url(/img/arrow2.cur), pointer;
} 

_:-ms-lang(x), .carousel-control-next {
  cursor: url(/img/arrow.cur), pointer;
} 
/*
.carousel-item{
    transition: -webkit-transform .7s ease;
    -webkit-transition: -webkit-transform .7s ease;
    transition: transform .7s ease;
    transition: transform .7s ease, -webkit-transform .7s ease;
    transition: transform .7s ease,-webkit-transform .7s ease;
}
*/
.carousel-control-next, .carousel-control-prev { width: 20% !important; }
</style>
